<mat-form-field appearance="fill" [class]="matFormClass" [subscriptSizing]="subscriptSizing">
    <mat-label>{{label}}</mat-label>
    <input 
        matInput
        [(ngModel)]="password"
        (ngModelChange)="onInputChange($event)"
        [type]="isPasswordVisible ? 'text' : 'password'" 
        [id]="inputId" 
        [required]="required" 
        [placeholder]="placeholder"
        [disabled]="disabled"
        [pattern]="passwordPolicyPattern"
        (keydown)="detectCapsLock($event)">
    <mat-icon matSuffix *ngIf="capsLockOn" matTooltip="Caps Lock is on">lock</mat-icon>
    <mat-icon matSuffix id="{{inputId}}-password-show-input" (click)="isPasswordVisible = !isPasswordVisible">
        {{ isPasswordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
    <mat-icon matSuffix *ngIf="tooltip" [matTooltip]="tooltip" [matTooltipDisabled]="tooltipDisabled">help</mat-icon>
</mat-form-field>

<app-password-validation *ngIf="passwordPolicy || confirmPassword"
    [passwordComponent]="this">
</app-password-validation>
